export default "__VITE_ASSET__Bpl58Qr___"